import React, { ReactNode } from 'react';
import {
    Row,
} from 'react-table';
import { RowProps } from '../..';
import { Td, Tr } from '../../styles';
import Icon from 'components/atoms/Icon';

export interface RowExtendableProps<T extends object> {
    extendable: boolean,
    child?: ReactNode,
    onExtendableClick?: (item: T) => void,
    isExpanded?: boolean,
    onExpand?: () => void
}

export interface TableRowProps<T extends object> {
    row: Row<T>,
    rowProps: RowProps<T> | undefined,
    showFooterWithSingularPage: boolean,
    rowExtendableProps?: RowExtendableProps<T>
}

const TableRow = <T extends object>({ row, rowProps, showFooterWithSingularPage, rowExtendableProps }: TableRowProps<T>) => {
    const onClick = () => {
        if (rowProps?.onClick) {
            rowProps.onClick(row.original);
        }
        if (rowExtendableProps) {
            if (rowExtendableProps.extendable) {
                if (rowExtendableProps.onExtendableClick) {
                    rowExtendableProps.onExtendableClick(row.original);
                }
                if (rowExtendableProps.onExpand) {
                    rowExtendableProps.onExpand();
                }
            }
        }
    };

    return (
        <>
            <Tr {...row.getRowProps()} onClick={onClick}>
                {rowExtendableProps?.extendable ?
                    <Icon name={rowExtendableProps.isExpanded ? 'chevron-up' : 'chevron-down'} size={2.5} /> : null
                }
                {row.cells.map((cell) => {
                    return (
                        <>
                            <Td
                                isClick={!!rowProps?.onClick}
                                {...cell.getCellProps()}
                                hideFooter={!showFooterWithSingularPage}
                            >
                                {cell.render('Cell')}
                            </Td>
                        </>
                    );
                })}
            </Tr>
            <Tr>
                {rowExtendableProps && rowExtendableProps.isExpanded && rowExtendableProps.child ? rowExtendableProps.child : null}
            </Tr>
        </>
    );
};

export default TableRow;
